import { render } from "./Prioritizing_issue.vue?vue&type=template&id=2afc0752&scoped=true"
import script from "./Prioritizing_issue.vue?vue&type=script&lang=js"
export * from "./Prioritizing_issue.vue?vue&type=script&lang=js"

import "./Prioritizing_issue.vue?vue&type=style&index=0&id=2afc0752&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afc0752"]])

export default __exports__